import createComponent from '@carvana/merch-components/createComponent';

export const SectionWrapper = createComponent('div', {
  className: 'w-full '
});
